import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useApplicantStore from '../../../store/applicantStore/useApplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const EmploymentSection = (): ReactNode => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      currentIncomeAmount,
      currentIncomeDuration,
      currentIncomeStatus,
      currentIncomeType,
    },
  } = useApplicantStore();

  return (
    <span data-testid={locator.components.employmentSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.employmentSection.h3}>
          {t('ApplicantReviewPage.employment')}
        </h3>
        <Link
          data-testid={locator.components.employmentSection.editLink}
          to={`/applicant/${vehicleId}/edit-employment`}
        >
          {t('ApplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.status')}</dt>
            <dd data-testid={locator.components.employmentSection.status}>
              {currentIncomeStatus}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.type')}</dt>
            <dd data-testid={locator.components.employmentSection.incomeType}>
              {currentIncomeType}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.income')}</dt>
            <dd data-testid={locator.components.employmentSection.amount}>
              {currentIncomeAmount}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.duration')}</dt>
            <dd data-testid={locator.components.employmentSection.duration}>
              {currentIncomeDuration}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default EmploymentSection;
